export default {
  wrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '12px',
  },
  searchBox: {},
}



// WEBPACK FOOTER //
// ./src/Components/PostcodesSearch/styles.js